// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"_1iIbU"};